import { DocumentNode, useMutation } from "@apollo/client";
import { toast } from "sonner";
import { useConfirmation } from "@/context/ConfirmationContext";

interface UseDeleteConfirmationProps {
  mutation: DocumentNode;
  refetchQueries: string[];
  messages?: {
    success?: string;
    error?: string;
  };
  itemName?: string;
}

export const useDeleteConfirmation = ({
  mutation,
  refetchQueries,
  messages = {
    success: "Items deleted successfully",
    error: "Failed to delete items",
  },
  itemName = "item",
}: UseDeleteConfirmationProps) => {
  const { showConfirmation } = useConfirmation();
  const [deleteItems] = useMutation(mutation, {
    refetchQueries,
  });

  const onDelete = (rows: any[]) => {
    showConfirmation({
      onConfirm: async () => {
        try {
          await deleteItems({
            variables: {
              ids: rows.map((row: any) => row.id),
            },
          });
          toast.success(messages.success);
        } catch (error) {
          toast.error(messages.error);
        }
      },
      description: `Are you sure you want to delete ${rows.length} ${itemName}${
        rows.length === 1 ? "" : "s"
      }?`,
      confirmText: "Delete",
      cancelText: "Cancel",
    });
  };

  return {
    onDelete,
  };
};
